import React, { useState, useContext, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronUp, FaUser, FaSignOutAlt } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import appbarIcon from '../../assets/appbar_icon.png';
import { SIDEBAR_PLAN_COLORS, PLAN_LABELS, DEFAULT_PLAN_COLOR, DEFAULT_PLAN_CIRCLE_COLOR } from './planTheme';
import './SidebarProfile.css';

const SidebarProfile = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  const fullName = user?.name?.trim();
  const firstName = fullName
    ? fullName.split(/\s+/)[0]
    : (user?.email ? user.email.split('@')[0] : 'Account');

  const isActivePlan = Boolean(user?.planId) && user?.status === 'active';
  const planColor = isActivePlan ? (SIDEBAR_PLAN_COLORS[user.planId] || DEFAULT_PLAN_COLOR) : DEFAULT_PLAN_COLOR;
  const circleColor = isActivePlan ? (SIDEBAR_PLAN_COLORS[user.planId] || DEFAULT_PLAN_CIRCLE_COLOR) : '#FFFFFF';
  const planLabel = isActivePlan ? (PLAN_LABELS[user.planId] || user.planId) : 'No Plan';

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
    navigate('/');
  };

  return (
    <div className="sidebar-profile" ref={containerRef}>
      <div className={`sidebar-profile-menu ${menuOpen ? 'sidebar-profile-menu-open' : ''}`}>
        <button
          type="button"
          className="sidebar-profile-menu-item"
          onClick={() => { setMenuOpen(false); navigate('/settings'); }}
        >
          <FaUser size={15} /> Profile
        </button>
        <button
          type="button"
          className="sidebar-profile-menu-item sidebar-profile-menu-item-logout"
          onClick={handleLogout}
        >
          <FaSignOutAlt size={15} /> Log out
        </button>
      </div>

      <button
        type="button"
        className="sidebar-profile-trigger"
        onClick={() => setMenuOpen((v) => !v)}
        aria-expanded={menuOpen}
        aria-haspopup="true"
      >
        <span className="sidebar-profile-avatar" style={{ backgroundColor: circleColor }}>
          {isActivePlan && (
            <img src={appbarIcon} alt="" className="sidebar-profile-avatar-mark" draggable="false" />
          )}
        </span>
        <span className="sidebar-profile-info">
          <span className="sidebar-profile-name">{firstName}</span>
          <span className="sidebar-profile-plan" style={{ color: planColor }}>{planLabel}</span>
        </span>
        <FaChevronUp className={`sidebar-profile-chevron ${menuOpen ? 'sidebar-profile-chevron-open' : ''}`} size={17} />
      </button>
    </div>
  );
};

export default SidebarProfile;
